import React, { useContext, useState } from 'react';
import { Divider, ListItemButton, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import BottomNavigation from 'components/BottomNavigation';
import { TAB_MENU } from 'types/room';
import { SESSION_TYPE } from 'types/chat';
import useMobile from 'hooks/useMobile';
import NoConversations from 'components/NoConversations';
import { LoadingWrapper } from 'views/home/Settings/style';
import { flag, useFeatureFlag } from 'hooks/useFeatureFlag';
import MenuChatsContext from '../../../../contexts/menuChats/context';
import { IAccordeon } from '../../../../contexts/menuChats/types';
import { SessionInfoView } from '../../../../components/sessions/SessionInfoView';
import { CollapseView } from '../../../../components/sessions/CollapseView';
import SearchAndStatusBar from '../../../../components/SearchAndStatusBar';
import { ReactComponent as Loading } from '../../../../assets/icons/loadingYalo.svg';
import ChatItemFilter from '../../../../components/ChatItemFilter';
import ChatsContext from '../../../../contexts/chats/context';
import AuthContext from '../../../../contexts/auth/context';
import ChatTabsMenu from '../ChatTabsMenu';
import { ChatList, ContainerListChats } from '../style';

const AllChats: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const {
    accordeonsAllChats,
    handleExpand,
    searchAllChats,
    handleSearchChats,
    isSearchAllChats,
    isLoading,
    refreshTemplates,
  } = useContext(MenuChatsContext);
  const { goToNewChat } = useContext(ChatsContext);
  const { allowsManualOnHold } = useContext(AuthContext);
  const isStartedByYouEnabled = useFeatureFlag(flag.STARTED_BY_YOU);
  const { showMobile } = useMobile();
  const [preValue, setPreValue] = useState('');
  const showAllChats = !isSearchAllChats && !!accordeonsAllChats?.length;

  const handleClickSettings = () => {
    navigate('/mobile-settings');
  };

  const handleChatClick = () => {
    navigate('/');
  };

  const chats = accordeonsAllChats?.filter((item) => {
    const shouldRemoveOnHold = item.id === SESSION_TYPE.ON_HOLD && !allowsManualOnHold;
    return !shouldRemoveOnHold;
  });

  return (
    <ContainerListChats>
      <SearchAndStatusBar
        value={preValue}
        handleChangeSearch={(value: string) => {
          if (value !== 'delete') {
            handleSearchChats('allChats', value);
            setPreValue(value);
          } else {
            const newValue = preValue.substring(0, preValue.length - 1);

            handleSearchChats('allChats', newValue);
            setPreValue(newValue);
          }
        }}
      />

      <ChatList disablePadding>
        {isSearchAllChats &&
          searchAllChats &&
          searchAllChats.length > 1 &&
          searchAllChats.map((item, index) => (
            <React.Fragment key={index}>
              <ChatItemFilter
                tabType="allChats"
                id={item._id}
                name={item.fname}
                closedAt={item.closedAt}
                department={item.department}
                closedBy={item.closedBy}
                servedBy={item.servedBy}
                handleOpenChat={() => goToNewChat(item)}
              />
              <Divider variant={index === searchAllChats.length - 1 ? 'fullWidth' : 'inset'} component="li" />
            </React.Fragment>
          ))}

        {showMobile && showAllChats ? (
          <ChatTabsMenu chats={chats} type={TAB_MENU.ALL_CHATS} isLoading={isLoading} />
        ) : null}

        {isLoading && (
          <LoadingWrapper data-testid="loadingWrapper">
            <Loading />
          </LoadingWrapper>
        )}

        {!showMobile && showAllChats
          ? chats.map((item: IAccordeon) => {
              if (item.id === SESSION_TYPE.STARTED_BY_YOU && !isStartedByYouEnabled) {
                return null;
              }

              return (
                <React.Fragment key={item.id}>
                  <div>
                    <ListItemButton
                      disableGutters
                      onClick={() => {
                        handleExpand(item, 'accordeonsAllChats');
                      }}
                      style={{
                        position: 'sticky',
                        zIndex: 99,
                      }}
                      sx={{
                        ':hover': {
                          background: `${theme.palette.neutral.var10} !important`,
                        },
                      }}
                    >
                      <SessionInfoView type={TAB_MENU.ALL_CHATS} item={item} refreshAction={refreshTemplates} />
                    </ListItemButton>
                  </div>
                  <Divider variant="fullWidth" component="li" />
                  {item.id === SESSION_TYPE.STARTED_BY_YOU && item.templates?.length ? (
                    <CollapseView type={TAB_MENU.YOUR_CHATS} item={item} />
                  ) : null}
                  {item.rooms.length ? <CollapseView type={TAB_MENU.ALL_CHATS} item={item} /> : null}
                </React.Fragment>
              );
            })
          : null}

        {isSearchAllChats && !searchAllChats.length ? <NoConversations title="notFoundChats" /> : null}

        {showMobile && (
          <Stack position="fixed" bottom="1.8rem" left="1.2rem" right="1.2rem" zIndex={1}>
            <BottomNavigation
              conversationAction={handleChatClick}
              settingsAction={handleClickSettings}
              currentActiveIndex={0}
            />
          </Stack>
        )}
      </ChatList>
    </ContainerListChats>
  );
};

export default AllChats;
